/**
 * Converts a cell address `z/x/y` to a tile bounding box.
 * @param cellAddress The cell address to convert in format `z/x/y`
 * @returns The tile bounding box in format `[minLng, minLat, maxLng, maxLat]`
 */
export function cellAddressToTileBBox(cellAddress: string) {
  const [z, x, y] = cellAddress.split("/").map(Number);

  const minLng = (x / Math.pow(2, z)) * 360 - 180;
  const minLat = (Math.atan(Math.sinh(Math.PI * (1 - (2 * y) / Math.pow(2, z)))) * 180) / Math.PI;

  const maxLng = ((x + 1) / Math.pow(2, z)) * 360 - 180;
  const maxLat = (Math.atan(Math.sinh(Math.PI * (1 - (2 * (y + 1)) / Math.pow(2, z)))) * 180) / Math.PI;

  return [minLng, minLat, maxLng, maxLat] as const;
}
